import country from "./country.component";
import countryUrls from "./country.urls";
import CountryTransforms from "./country.transforms";

const countryModule = angular
  .module("app.components.country", [])
  .component("countryPage", country)
  .service("CountryTransforms", CountryTransforms)
  .config(countryUrls);

export default countryModule;



// WEBPACK FOOTER //
// ./src/pages/country/country.module.js